import { render, staticRenderFns } from "./FactorList.vue?vue&type=template&id=df800020&"
import script from "./FactorList.vue?vue&type=script&lang=js&"
export * from "./FactorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports